import { useRouter } from 'next/router';

import { Stack } from '@reckon-web/stack';
import { Heading } from '@reckon-web/heading';
import { Text } from '@reckon-web/text';
import { Button } from '@reckon-web/button';
import { HeroNotFound } from '@reckon-web/illustration';

const Custom404 = () => {
  const router = useRouter();
  return (
    <div>
      <Stack align="center" gap="xxlarge" css={{ marginTop: '100px' }}>
        <HeroNotFound />
        <Stack align="center" gap="large">
          <Heading align="center" level="3">
            Page not found
          </Heading>
          <Text
            color="muted"
            size="small"
            leading="loose"
            weight="medium"
            align="center"
          >
            We can't find the page you're looking for. It might be an old link,{' '}
            <br />
            or maybe the page has moved.
          </Text>
        </Stack>
        <Button
          id="404-go-home"
          label="Go to Work"
          onClick={() => router.push('/')}
        />
      </Stack>
    </div>
  );
};

export default Custom404;
